// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__ofeFi","trailing":"Button_trailing__qzA1S","primary":"Button_primary__dQH6j","ghost":"Button_ghost__d0x+e","underline":"Button_underline__G6Q8U"};